// extracted by mini-css-extract-plugin
export default {"newsWrapper":"newsView_newsWrapper__2gy3K","newsItem":"newsView_newsItem__2NZwN","newsTitle":"newsView_newsTitle__DoCIU","img":"newsView_img__9jhd2","img1":"newsView_img1__NdZdQ"};